// WhatsApp Template Manager
import { CONTACT_INFO } from '../data/mockData';

export const generateWhatsAppLink = (templateName, variables = {}) => {
  const templates = {
    generic: `Hi Rocket Van Express, I need a quote.
Pickup: ${variables.pickup || '__'}
Drop-off: ${variables.dropoff || '__'}
Items: ${variables.items || '__'}
Date/time: ${variables.datetime || '__'}`,

    delivery: `Hi Rocket Van Express, I need a DELIVERY quote.
Ref: ${variables.refId || 'LEAD-' + Date.now()}
Pickup: ${variables.pickup || '__'}
Drop-off: ${variables.dropoff || '__'}
Item: ${variables.item || '__'}
Date/time: ${variables.datetime || '__'}
${variables.partnerCode ? `Partner: ${variables.partnerCode}` : ''}
${variables.utmCampaign ? `Source: ${variables.utmCampaign}` : ''}`,

    miniMove: `Hi Rocket Van Express, I need a MINI-MOVE quote.
Ref: ${variables.refId || 'LEAD-' + Date.now()}
Pickup pin: ${variables.pickup || '__'}
Drop-off pin: ${variables.dropoff || '__'}
Items: ${variables.items || '__'}
Helpers: ${variables.helpers || '__'}
Date/time: ${variables.datetime || '__'}
Photos: (sending)
${variables.partnerCode ? `Partner: ${variables.partnerCode}` : ''}`,

    business: `Hi Rocket Van Express, I'd like a BUSINESS account.
Ref: ${variables.refId || 'LEAD-' + Date.now()}
Company: ${variables.businessName || '__'}
Monthly deliveries: ${variables.volume || '__'}
Areas: ${variables.area || '__'}
Email: ${variables.email || '__'}`,

    track: `Hi Rocket Van Express, I need to track my booking.
Reference: ${variables.bookingRef || '__'}`,

    reschedule: `Hi Rocket Van Express, I need to reschedule.
Ref: ${variables.refId || '__'}
Current: ${variables.currentDatetime || '__'}
New: ${variables.newDatetime || '__'}
Reason: ${variables.reason || 'N/A'}`,

    cancel: `Hi Rocket Van Express, I need to cancel my booking.
Ref: ${variables.refId || '__'}
Reason: ${variables.reason || 'N/A'}`,

    damageClaim: `Hi Rocket Van Express Support, I need to log a damage claim.
Ref: ${variables.refId || '__'}
Description: ${variables.description || '__'}
Photos: (sending)`,

    support: `Hi Rocket Van Express Support, I need help with: ${variables.issue || '__'}
Ref: ${variables.refId || '__'}`,

    pricing: `Hi Rocket Van Express, I'd like to know about pricing.
Service: ${variables.serviceType || '__'}
From: ${variables.pickup || '__'}
To: ${variables.dropoff || '__'}`,

    referral: 'Hi Rocket Van Express, I want a referral code.',

    review: `Hi Rocket Van Express, I'd like to leave a review.
Ref: ${variables.refId || '__'}`,

    partnerQuote: `Hi Rocket Van Express, I'm inquiring through ${variables.partnerName || 'partner'}.
Partner code: ${variables.partnerCode || '__'}
Service: ${variables.serviceType || '__'}
Details: ${variables.details || '__'}`
  };

  const message = templates[templateName] || templates.generic;
  const encodedMessage = encodeURIComponent(message);
  
  return `https://wa.me/${CONTACT_INFO.whatsapp}?text=${encodedMessage}`;
};

// Track WhatsApp clicks
export const trackWhatsAppClick = (context, analytics) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'whatsapp_click', {
      event_category: 'engagement',
      event_label: context.templateName || 'generic',
      page: context.page || window.location.pathname,
      service_type: context.serviceType || 'unknown',
      suburb: context.suburb || '',
      partner_code: context.partnerCode || '',
      utm_campaign: context.utmCampaign || ''
    });
  }
};

export default { generateWhatsAppLink, trackWhatsAppClick };
